const campusPodTableHeading = [
  {
    key: "podNumber",
    label: "POD Number",
  },
  {
    key: "podType",
    label: "POD type",
  },
  {
    key: "status",
    label: "Status",
    format: (value) => (value ? "Active" : "Not Active"),
  },
  {
    key: "vendor",
    label: "Vendor ID",
  },
  
];

export { campusPodTableHeading };
